export default __webpack_public_path__ + "static/media/vsp-04156.b8439e52.jpg";